export class CriterioBusquedaObtenerResumenDTO {
  numeroCuenta?: string;
  numeroCliente?: string;  
}